<template>
  <div>
    <wrapper-edit
      :wrapper-width="wrapperWidth"
      @back="paasPageBack">
      <Form ref="paasForm" slot="form"
            :model="paasFormData"
            :rules="paasFormRules"
            :label-width="defaultLabelWidth">
        <Row>
          <FormItem label="分类名称：" prop="name" class="ivu-col-span-24" >
            <Input v-model="paasFormData.name"
                   clearable ></Input>

          </FormItem>
        </Row>
        <Row>
          <FormItem label="分类字段：" prop="engTitle" class="ivu-col-span-24" >
            <Input v-model="paasFormData.engTitle"
                   clearable ></Input>

          </FormItem>
        </Row>
        <Row>
          <FormItem label="图标：" prop="icon" class="ivu-col-span-24" >
            <!--<Input v-model="paasFormData.icon"
                   clearable ></Input>-->
            <Input v-model="paasFormData.icon" placeholder="图标" >
            <Button slot="append"  @click="funcIcon">
              <Icon :type="paasFormData.icon ? paasFormData.icon : 'ios-search'">
              </Icon>
            </Button>
            </Input>
          </FormItem>
        </Row>
        <Row>
          <FormItem label="类型：" prop="type" class="ivu-col-span-24" >
            <Enum :enumJsonKey="'crmdict-configType'"  v-model="paasFormData.type"  type="radio" ></Enum>

          </FormItem>
        </Row>
        <Row>
          <FormItem label="是否显示：" prop="info" class="ivu-col-span-24" >
            <Enum :enumJsonKey="'crmdict-isShow'"  v-model="paasFormData.info"  type="radio" ></Enum>

          </FormItem>
        </Row>
        <Row>
          <FormItem label="排序：" prop="displayOrder" class="ivu-col-span-20">
            <Input v-model="paasFormData.displayOrder"
                   clearable placeholder="请输入排序"></Input>

          </FormItem>
        </Row>
        <div class="edit-oper-toolbar">
          <Button type="primary" @click="paasFormSubmit('paasForm','','add')">保存并继续添加</Button>
          <Button @click="paasFormSubmit('paasForm','','systemConfigTabList')" style="margin-left: 8px">保存并返回</Button>
          <Button @click="paasPageBack" style="margin-left: 8px">返回</Button>
        </div>
      </Form>
      <Modal v-model="funcIconModal" class="paas-select-page" width="80" title="图标选择" :styles="{top: '10px'}">
        <IconSelect @save="saveIcon" type="icon"/>
        <div slot="footer">
        </div>
      </Modal>
    </wrapper-edit>
  </div>
</template>
<script>
  import wrapperEdit from "@/components/paas/wrapper-edit";
  import metaEdit from "@/assets/js/meta-edit.js";
  import Enum from '@/components/paas/enum-form' //枚举渲染
  import IconSelect from '@/components/icon/icon'

  export default {
    name: "edit",
    mixins:[metaEdit],
    components:{wrapperEdit,Enum,IconSelect},
    data(){
      return {
        serviceUrl:"/eb/system/config/tab",  //每个页面访问后台服务器的路径
        currentIdFiledName: 'id',
        paasFormData:{
          id:'',
          name:'',
          engTitle:'',
          icon:'',
          type:'',
          info:'',
          status:'',
        },
        paasFormRules:{
        },
        redirectName:"systemConfigTabList",
        nextAddName:"systemConfigTabEdit",
        funcIconModal:false,
      }
    },
    methods:{
      // 选择icon
      funcIcon() {
        this.funcIconModal = true;
      },
      saveIcon(item) {
        if(this.funcIconModal === true){
          this.paasFormData.icon = item;
          this.funcIconModal = false;
        }
      },
    }
  }
</script>


